(function () {
  'use strict';
  var root = document.querySelector('[data-collection-search]');
  if (!root || !root.dataset.query) return;
  var pageURL = new URL(location.href);
  var value = root.dataset.query;
  if (!(pageURL.searchParams.get('q') || '').includes('(title:')) {
    var words = value.replace(/["*\\]/g, '').trim().split(/\s+/).filter(Boolean);
    if (words.length) {
      pageURL.searchParams.set('q', words.map(function (word) { return '(title:"' + word + '" OR tag:"' + word + '")'; }).join(' AND '));
      pageURL.searchParams.set('type', 'product'); pageURL.searchParams.set('sort_by', 'relevance');
      pageURL.searchParams.delete('page'); location.replace(pageURL.href); return;
    }
  }
  var target = root.querySelector('[data-collection-search-results]');
  var controller = new AbortController();
  var timeout = setTimeout(function () { controller.abort(); }, 12000);
  async function collectionSection(url) {
    var requestURL = new URL(url, location.origin);
    requestURL.searchParams.set('section_id', 'search-collection-products');
    var response = await fetch(requestURL, { signal: controller.signal });
    if (!response.ok) throw new Error('Collection unavailable');
    var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    var group = doc.querySelector('[data-collection-group]');
    if (!group) throw new Error('Collection unavailable');
    return group;
  }
  var url = new URL(root.dataset.searchUrl + '/suggest.json', location.origin);
  url.searchParams.set('q', value); url.searchParams.set('resources[type]', 'collection'); url.searchParams.set('resources[limit]', '10');
  fetch(url, { signal: controller.signal }).then(function (response) { if (!response.ok) throw new Error('Search unavailable'); return response.json(); }).then(async function (data) {
    var collections = data.resources.results.collections || [];
    // Keep a direct route to every matching collection, even if a preview fails.
    if (!collections.length) return;
    var nav = document.createElement('div'); nav.className = 'tt-collection-search__links';
    collections.forEach(function (collection) { var link = document.createElement('a'); link.href = collection.url; link.textContent = collection.title; nav.append(link); });
    target.append(nav); root.hidden = false;
    var previews = await Promise.allSettled(collections.slice(0, 3).map(function (collection) { return collectionSection(collection.url); }));
    previews.forEach(function (result) { if (result.status === 'fulfilled') target.append(document.importNode(result.value, true)); });
  }).catch(function () { /* Native title/tag results remain usable. */ }).finally(function () { clearTimeout(timeout); });
  target.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-collection-next]'); if (!button) return;
    var group = button.closest('[data-collection-group]'); button.disabled = true; button.textContent = 'Loading…';
    controller = new AbortController(); timeout = setTimeout(function () { controller.abort(); }, 12000);
    try {
      var url = new URL(button.dataset.collectionNext, location.origin);
      // Paginate URLs from a rendered collection remain scoped to that collection.
      var next = await collectionSection(url);
      next.querySelectorAll('.tt-search__product').forEach(function (card) { group.querySelector('.tt-collection-search__grid').append(document.importNode(card, true)); });
      var more = next.querySelector('[data-collection-next]');
      if (more) { button.dataset.collectionNext = more.dataset.collectionNext; button.textContent = 'Show more from this collection'; button.disabled = false; }
      else button.remove();
    } catch (error) { button.textContent = 'Try loading more again'; button.disabled = false; }
    finally { clearTimeout(timeout); }
  });
})();